module.exports = __webpack_public_path__ + "dingbeauty/admin/img/fbCode_n2.4b6a1924.png";